import { render, staticRenderFns } from "./token-details.vue?vue&type=template&id=5f560286&scoped=true&"
import script from "./token-details.vue?vue&type=script&lang=ts&"
export * from "./token-details.vue?vue&type=script&lang=ts&"
import style0 from "./token-details.vue?vue&type=style&index=0&id=5f560286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f560286",
  null
  
)

export default component.exports